import { useEffect, useRef } from 'react';
import { api } from '../services/api';
import { getCartSessionId } from '../utils/cartSession';

export default function useCartReserva(items, { canal = 'web', enabled = true, onAdjusted } = {}) {
  const timer = useRef(null);
  const onAdjustedRef = useRef(onAdjusted);
  onAdjustedRef.current = onAdjusted;

  useEffect(() => {
    if (!enabled) return undefined;
    const sessionId = getCartSessionId();
    const payloadItems = (items || []).map((it) => ({
      codigo: it.codigo,
      cantidad: it.cantidad,
    }));

    async function sync() {
      try {
        if (!payloadItems.length) {
          await api.clearCartReserva?.(sessionId);
          return;
        }
        const res = await api.syncCartReserva?.({
          session_id: sessionId,
          canal,
          items: payloadItems,
        });
        if (res?.data?.adjusted?.length && onAdjustedRef.current) {
          onAdjustedRef.current(res.data.adjusted);
        }
      } catch {
        /* ignore */
      }
    }

    clearTimeout(timer.current);
    timer.current = setTimeout(sync, 400);
    const heartbeat = setInterval(sync, 10 * 60 * 1000);

    return () => {
      clearTimeout(timer.current);
      clearInterval(heartbeat);
    };
  }, [items, canal, enabled]);

  return { sessionId: getCartSessionId() };
}
